module.exports = __webpack_public_path__ + "assets/images/fd51c0a420b47437236f64b146d8bd8d.png";